module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dayCalContainer",
    staticClass: "day-cal__event-container",
    class: {
      'day-cal__event-container--no-bg-colors': _vm.isCalNoBgColors
    }
  }, [_c('div', {
    staticClass: "day-cal__event-container__events"
  }, _vm._l((_vm.correctEvents), function(event) {
    return _c('div', {
      key: event.obj.event_key,
      staticClass: "day-cal__event",
      class: [{
        'day-cal__event--is-away': event.obj.away
      }, {
        'day-cal__event--is-canceled': event.obj.canceled
      }, {
        'fc-bgevent__presence': event.obj.event_type === 'presence'
      }, {
        'day-cal__event--clickable': _vm.isEventsClickable
      }],
      style: ({
        'borderColor': event.obj.color,
        'height': event.height + 'px',
        'top': (event.top - 1) + 'px',
        'left': event.left + '%',
        'width': event.width + '%'
      }),
      attrs: {
        "data-cols": event.cols ? event.cols : 1
      },
      on: {
        "click": function($event) {
          return _vm.onEventClick(event, $event)
        }
      }
    }, [_c('div', {
      staticClass: "day-cal__event__content",
      style: ({
        fontSize: _vm.eventFontSize !== 10 ? _vm.eventFontSize + 'px' : ''
      })
    }, [_c('div', {
      staticClass: "day-cal__event__content__header"
    }, [_c('div', {
      staticClass: "d-cal__event-title"
    }, [(event.obj.away) ? _c('span', {
      staticClass: "icon-home2 icon-home2-away icon-home2-away--schedules"
    }) : _vm._e(), _vm._v(_vm._s(event.obj.title))]), _vm._v(" "), _c('div', {
      staticClass: "d-cal__event-time"
    }, [_c('span', {
      staticClass: "d-cal__event-time__start"
    }, [_vm._v(_vm._s(event.obj.event_starttime))]), _vm._v(" "), _c('span', {
      staticClass: "d-cal__event-time__end"
    }, [_vm._v(_vm._s(event.obj.event_endtime))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (event.obj.has_notes && !_vm.isCalendarInPrintMode),
        expression: "event.obj.has_notes && !isCalendarInPrintMode"
      }],
      staticClass: "d-cal__event-meta icon-file-text2"
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (event.obj.has_substitute),
        expression: "event.obj.has_substitute"
      }],
      staticClass: "d-cal__event-meta icon-users3"
    }), _vm._v(" "), (event.obj.collision || event.obj.away || event.obj.canceled) ? _c('div', {
      staticClass: "d-cal__event-meta d-cal__event-meta__fixed d-cal__event-meta--warning",
      class: {
        'd-cal__event-meta__fixed--canceled': event.obj.canceled
      }
    }, [(event.obj.canceled) ? _c('span', {
      staticClass: "icon-notification22"
    }) : _c('svg', {
      staticClass: "tw-icon tw-icon--warning",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
      }
    })]), _vm._v("\n              " + _vm._s(_vm.getEventWarningLabel(event.obj)) + "\n            ")]) : _vm._e()])]), _vm._v(" "), (!_vm.isHideCalendars) ? [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (event.obj.teacher),
        expression: "event.obj.teacher"
      }],
      staticClass: "day-cal__event__calendar"
    }, [_c('span', {
      staticClass: "icon-user"
    }), _vm._v("\n            " + _vm._s(event.obj.teacher) + "\n          ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (event.obj.group),
        expression: "event.obj.group"
      }],
      staticClass: "day-cal__event__calendar"
    }, [_c('span', {
      staticClass: "icon-users"
    }), _vm._v("\n            " + _vm._s(event.obj.group) + "\n          ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (event.obj.room),
        expression: "event.obj.room"
      }],
      staticClass: "day-cal__event__calendar"
    }, [_c('span', {
      staticClass: "icon-location"
    }), _vm._v("\n            " + _vm._s(event.obj.room) + "\n          ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (event.obj.students),
        expression: "event.obj.students"
      }],
      staticClass: "day-cal__event__calendar"
    }, [_c('span', {
      staticClass: "icon-users5"
    }), _vm._v("\n            " + _vm._s(event.obj.students) + "\n          ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "day-cal__event__bg",
      style: ({
        backgroundColor: event.obj.color
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "day-cal__event__sider",
      style: ({
        backgroundColor: event.obj.color
      })
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3347a2de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendarDay.vue
// module id = 1844
// module chunks = 1